import type { ResourceProps } from "@refinedev/core";
import {
  BankOutlined,
  BellOutlined,
  BugOutlined,
  ContactsOutlined,
  ContainerOutlined,
  CopyOutlined,
  CreditCardOutlined,
  DashboardOutlined,
  FileSearchOutlined,
  FilterOutlined,
  FunnelPlotOutlined,
  HistoryOutlined,
  RiseOutlined,
  RobotOutlined,
  SearchOutlined,
  SendOutlined,
  SettingOutlined,
  ShoppingOutlined,
  TeamOutlined,
  UserOutlined,
  WarningOutlined,
} from "@ant-design/icons";

// Menu boczne: grupy to zasoby bez `list` — Refine (`useMenu`) układa pod nimi zasoby
// z `meta.parent`. Nazwy zasobów i trasy się nie zmieniają, więc `useTable({ resource })`
// i linki zostają ważne. Etykiety dzieci są krótkie, bo kontekst daje grupa.

const group = (name: string, label: string, icon: React.ReactNode): ResourceProps => ({
  name,
  meta: { label, icon },
});

export const resources: ResourceProps[] = [
  group("group-clients", "Klienci", <TeamOutlined />),
  {
    name: "users",
    list: "/users",
    meta: { parent: "group-clients", label: "Użytkownicy", icon: <UserOutlined /> },
  },
  {
    name: "user-searches",
    list: "/user-searches",
    meta: { parent: "group-clients", label: "Wyszukiwania klienta", icon: <SearchOutlined /> },
  },
  {
    name: "clients-at-risk",
    list: "/clients-at-risk",
    meta: { parent: "group-clients", label: "Klienci z problemami", icon: <WarningOutlined /> },
  },
  {
    name: "filters",
    list: "/filters",
    edit: "/filters/edit/:id",
    meta: { parent: "group-clients", label: "Filtry klienta", icon: <FilterOutlined /> },
  },
  {
    name: "filter-copy",
    list: "/filter-copy",
    meta: { parent: "group-clients", label: "Kopiowanie filtru", icon: <CopyOutlined /> },
  },

  group("group-sales", "Sprzedaż", <ShoppingOutlined />),
  {
    name: "subscriptions",
    list: "/subscriptions",
    meta: { parent: "group-sales", label: "Subskrypcje", icon: <CreditCardOutlined /> },
  },
  {
    name: "purchases",
    list: "/purchases",
    meta: { parent: "group-sales", label: "Wpłaty przelewem", icon: <BankOutlined /> },
  },
  {
    name: "conversions",
    list: "/conversions",
    meta: { parent: "group-sales", label: "Konwersje", icon: <RiseOutlined /> },
  },
  {
    name: "funnel",
    list: "/funnel",
    meta: { parent: "group-sales", label: "Lejek marketingowy", icon: <FunnelPlotOutlined /> },
  },

  group("group-notifications", "Powiadomienia", <BellOutlined />),
  {
    name: "notifications",
    list: "/notifications",
    meta: { parent: "group-notifications", label: "Potok", icon: <DashboardOutlined /> },
  },
  {
    name: "notification-deliveries",
    list: "/notifications/deliveries",
    meta: { parent: "group-notifications", label: "Wysyłki", icon: <SendOutlined /> },
  },
  {
    name: "notification-subscriptions",
    list: "/notifications/subscriptions",
    meta: { parent: "group-notifications", label: "Odbiorcy", icon: <ContactsOutlined /> },
  },

  group("group-content", "Treści", <ContainerOutlined />),
  {
    name: "ai-tools",
    list: "/ai-tools",
    create: "/ai-tools/create",
    edit: "/ai-tools/edit/:id",
    show: "/ai-tools/show/:id",
    meta: { parent: "group-content", label: "Narzędzia AI", icon: <RobotOutlined /> },
  },
  {
    name: "auctions",
    list: "/auctions",
    edit: "/auctions/edit/:id",
    meta: { parent: "group-content", label: "Tytuły przetargów", icon: <FileSearchOutlined /> },
  },

  group("group-system", "System", <SettingOutlined />),
  {
    name: "scraper",
    list: "/scraper",
    meta: { parent: "group-system", label: "Diagnostyka scrapera", icon: <BugOutlined /> },
  },
  {
    name: "audit",
    list: "/audit",
    meta: { parent: "group-system", label: "Log administratora", icon: <HistoryOutlined /> },
  },
];
